import React, { PureComponent, Fragment } from 'react';
import { Link } from 'react-router-dom';
import * as Func from '../../../../../helpers/functions';
import {ListComponent, StatusComponent} from "../../../common/component/Index";
import Model from '../../../../../models/PopularPlace';
import { withTranslation } from "react-i18next";
import { Icon, Rate } from 'antd';
import Ripple from '../../../common/component/Ripple';

class PopularPlaceList extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            columns: this.getTableColumns(),
            filters: {},
        };
    }

    render() {
        const { loading, pagination, dataList } = this.props;
        const { columns } = this.state;
        return (
            <ListComponent
                tableKey="popular-place-list"
                // scroll={{ x: 1200 }}
                classChildren="p-0" classParent="m-0"
                rowKey={record => record.id}
                loading={{ spinning: loading, size: 'large' }}
                dataSource={dataList}
                columns={Func.columnsTable({
                    titleTable: columns,
                    component: this.renderTableBody(),
                    itemName: 'popularPlace'
                })}
                onChange={this.props.onChange}
                pagination={{ total: pagination.totalCount, totalPage: pagination.totalPage, defaultCurrent: pagination.defaultCurrent, defaultPageSize: pagination.pageSize }}
                componentTableList={{}}
            />
        );
    }

    renderTableBody() {
        return {
            name: {
                key: 'name',
            },
            averagePrice: {
                key: 'averagePrice',
                align: 'center',
                render: (text, record) => Func.formatMoney(Func.checkUndefine(record.averagePrice)),
            },
            numberOfVacancies: {
                key: 'numberOfVacancies',
                align: 'center',
            },
            order: {
                key: 'order',
                align: 'center',
            },
            isActive: {
                key: 'isActive',
                render: (isActive) => (
                    <StatusComponent color={isActive ? 'green' : 'red'}
                        label={isActive ? this.props.t('item.popularPlace.active') : this.props.t('item.popularPlace.deactive')} />
                )
            },
            action: {
                width: 100,
                align: 'center',
                key: 'action',
                render: (text, record) => this.renderEditComponent(record),
            }
        }
    }

    renderEditComponent(item) {
        const { t, permisions } = this.props;
        const onRemove = () => {
            if (confirm(Func.formatValidation(t('validation.statusCode.code.7'), t(`item.popularPlace.title`)))) { //eslint-disable-line
                return this.props.onDeletePopularPlace && this.props.onDeletePopularPlace(item)
            }
        };
        return (
            <Fragment>
                {
                    permisions && permisions.allowUpdate &&
                    <Link to={`/popular-places/action/${item.id}`} className={`mr-2 colorPrimary`}>
                        <Ripple><Icon type="form" className="fs20" /></Ripple>
                    </Link>
                }
                {/* {
                    permisions && permisions.allowDelete &&
                    <Ripple onClick={onRemove}><Icon type="delete" className="fs20 colorPrimary" /></Ripple>
                } */}
            </Fragment>
        )
    }

    getTableColumns() {
        const itemObj = new Model({});
        return Func.getTitleTable(Object.getOwnPropertyNames(itemObj), ['action'], ['id','image']);
    
    }


}

export default withTranslation()(PopularPlaceList);
